/* eslint-disable @typescript-eslint/naming-convention */
import {Injectable} from '@angular/core';
import {CommandMap, CommandsDescriptor} from '@app/models/commands/commands-descriptor';
import {CoreService} from '@app/services/core.service';
import {MessageRecord} from '@app/services/data.service';
import {Store} from '@ngxs/store';
import {ExecBuffer} from '@app/models/exec-buffer';

export enum CoreEvents {
  CHANNEL_OPEN = 'CHANNEL_OPEN',
  CHANNEL_RELOAD = 'CHANNEL_RELOAD',
  LOGOUT = 'LOGOUT',
  REDIRECT_STUDENT = 'REDIRECT_STUDENT',
  REDIRECT_CLASSROOM = 'REDIRECT_CLASSROOM',
  EXPEL_STUDENT = 'EXPEL_STUDENT',
  EXPEL_STAFF = 'EXPEL_STAFF',
  APPLAUSE = 'APPLAUSE',
  START_SPEAKING = 'START_SPEAKING',
  END_SPEAKING = 'END_SPEAKING',
  RESET_TEAM_SCORE = 'RESET_TEAM_SCORE',
  RESET_USERS = 'RESET_USERS',
  ADD_PROBLEM = 'ADD_PROBLEM',
}

export enum CoreStates {
  GAME_MODE = 'GAME_MODE',
  TEAMS_INFO = 'TEAMS_INFO',
  TEAM_TALK = 'TEAM_TALK',
  TEAM_NAME = 'TEAM_NAME',
  TEAM_SCORE = 'TEAM_SCORE',
  DO_NOT_DISTURB = 'DO_NOT_DISTURB',
  RAISE_HAND = 'RAISE_HAND',
  CANCEL_RAISE_HAND = 'CANCEL_RAISE_HAND',
  FULLSCREEN = 'FULLSCREEN',
  FULLSCREEN_OUT = 'FULLSCREEN_OUT',
  CURRENT_CLASS = 'CURRENT_CLASS',
  TEACHER_NICKNAME = 'TEACHER_NICKNAME',
  STICKERS = 'STICKERS',
  FIREWORK_ON = 'FIREWORK_ON',
  FIREWORK_OFF = 'FIREWORK_OFF',
  BREAK_TIMER = 'BREAK_TIMER',
  STOP_BREAK_TIMER = 'STOP_BREAK_TIMER',
  WB_SNAPSHOT_SAVING_STATUS = 'WB_SNAPSHOT_SAVING_STATUS',
}


@Injectable({
  providedIn: 'root'
})
export class CoreCommands extends CommandsDescriptor<CoreEvents, CoreStates> {

  static category = 'CORE';

  constructor(private coreService: CoreService, store: Store) {

    const MAP: CommandMap<CoreEvents, CoreStates> = {
      EVENT: {
        CHANNEL_OPEN: (record: MessageRecord) => this.coreService.onChannelOpen(record),
        CHANNEL_RELOAD: (record: MessageRecord) => this.coreService.onChannelReload(record),
        LOGOUT: (record: MessageRecord) => this.coreService.onLogout(record),
        REDIRECT_STUDENT: (record: MessageRecord) => this.coreService.onRedirectStudent(record),
        REDIRECT_CLASSROOM: (record: MessageRecord) => this.coreService.onRedirectClassroom(record),
        EXPEL_STUDENT: (record: MessageRecord) => this.coreService.onExpelStudent(record),
        EXPEL_STAFF: (record: MessageRecord) => this.coreService.onExpelStaff(record),
        APPLAUSE: (record: MessageRecord) => this.coreService.onApplause(record),
        START_SPEAKING: (record: MessageRecord) => this.coreService.onStartSpeaking(record),
        END_SPEAKING: (record: MessageRecord) => this.coreService.onEndSpeaking(record),
        RESET_TEAM_SCORE: (record: MessageRecord) => this.coreService.onResetTeamScore(record),
        RESET_USERS: (record: MessageRecord) => this.coreService.onResetUsers(record),
        ADD_PROBLEM: (record: MessageRecord) => this.coreService.onAddProblem(record),
      },
      STATE: {
        GAME_MODE: (record: MessageRecord) => this.coreService.onGameMode(record),
        TEAMS_INFO: (record: MessageRecord) => this.coreService.onTeamInfo(record),
        TEAM_TALK: (record: MessageRecord) => this.coreService.onTeamTalk(record),
        TEAM_NAME: (record: MessageRecord) => this.coreService.onTeamName(record),
        TEAM_SCORE: (record: MessageRecord) => this.coreService.onTeamScore(record),
        DO_NOT_DISTURB: (record: MessageRecord) => this.coreService.onToggleDND(record),
        RAISE_HAND: (record: MessageRecord) => this.coreService.onRaiseHand(record),
        CANCEL_RAISE_HAND: (record: MessageRecord) => this.coreService.onCancelRaiseHand(record),
        FULLSCREEN: (record: MessageRecord) => this.coreService.onFullScreen(record),
        FULLSCREEN_OUT: (record: MessageRecord) => this.coreService.onFullScreenOut(record),
        CURRENT_CLASS: (record: MessageRecord) => this.coreService.onSetClass(record),
        TEACHER_NICKNAME: (record: MessageRecord) => this.coreService.onTeacherNickname(record),
        STICKERS: (record: MessageRecord) => this.coreService.onSticker(record),
        FIREWORK_ON: (record: MessageRecord) => this.coreService.onFireworkOn(record),
        FIREWORK_OFF: (record: MessageRecord) => this.coreService.onFireworkOff(record),
        BREAK_TIMER: (record: MessageRecord) => this.coreService.onBreakTimer(record),
        STOP_BREAK_TIMER: () => this.coreService.onStopBreakTimer(),
        WB_SNAPSHOT_SAVING_STATUS: (record: MessageRecord) => this.coreService.onWhiteboardSnapshotSavingStatus(record),
      }
    };
    super(MAP, new ExecBuffer(true), store);
    this.coreService.handleRecordStack = this.handleRecordStack.bind(this);
  }
}
